import { Button } from "antd";
import Text from "components/Text";
import styled from "styled-components";
import { CloseCircleFilled } from '@ant-design/icons';

const StyledLayer = styled.div`
  width: 100%;
  height: 100%;
  z-index: 990;
  position: absolute;
  opacity: 0.9;
  background: black;
  top: 0;
  left: 0;
`;

const StyledContent = styled.div`
  position: absolute;
  z-index: 999;
  text-align: center;
  width: 100%;

  @media screen and (min-width: 960px) {
    img {
      width: 50% !important;
    }
  }
`;

/**
 * CustomMountModal
 * @param {*} props 
 * @returns 
 */
const CustomMountModal = (props) => {
  return (
    <>
      <CloseCircleFilled style={{ color: 'white', position: 'absolute', right: 10, top: 10, zIndex: 99999, fontSize: 26 }}  onClick={props.handleOnClose} />
      <StyledLayer onClick={props.handleOnClose} />
      <StyledContent>
        <div style={{ width: '75%', margin: 'auto'}}>
          

          <img src={`${process.env.REACT_APP_S3_FILES_URL}${props.mount.products[0].mount.output}`} style={{ width: '100%' }} alt={props.title} />
          
          <Text onClick={() => props.handleOnDownload(`${process.env.REACT_APP_S3_FILES_URL}${props.mount.products[0].mount.output}`)} underline color="white" align="center" style={{ cursor: 'pointer' }}>Télécharger</Text>
          
          <Button type="primary" style={{ marginTop: 10 }} onClick={() => props.handleOnSelectMount(props.mount)}>Imprimer sur un support</Button>
        </div>
      </StyledContent>
    </>
  )
}

export default CustomMountModal;